<script setup>
import {ref, onBeforeMount} from "vue"
import { lessonStateEnum } from "@/enum/lessonStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "PENDING"
  }
})
// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 课程状态枚举
const lessonState = lessonStateEnum

// 根据枚举返回订单状态
const handleEnum = () => {
  try {
    const lesson = lessonState.find(res => res.stateId === props.state)
    stateName.value = lesson.stateName ? lesson.stateName : "未知状态"
    switch (props.state) {
      case "PENDING":
        textType.value = "warning"
        break
      case "IN_PROGRESS":
        textType.value = "primary"
        break
      case "CANCELLED":
        textType.value = "info"
        break
      case "COMPLETED":
        textType.value = "success"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>